import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
    { to: "/", label: "Főoldal" },
    { to: "/szolgaltatasok", label: "Szolgáltatások" },
    { to: "/termekek", label: "Termékek" },
    { to: "/ajanlatkeres", label: "Ajánlatkérés" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const loc = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [loc.pathname]);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "backdrop-blur-xl bg-[#F9F6F0]/85 border-b border-[#4A3728]/10"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="nav-home-link"
                    className="flex items-baseline gap-2 group"
                >
                    <span className="font-serif text-2xl md:text-[28px] font-semibold tracking-tight text-[#2C2724] group-hover:text-[#4A3728] transition-colors">
                        BAU-Paks
                    </span>
                    <span className="overline hidden sm:inline">Kft.</span>
                </Link>

                <nav className="hidden lg:flex items-center gap-10">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-${l.label
                                .toLowerCase()
                                .replace(/\s/g, "-")}-link`}
                            className={({ isActive }) =>
                                `text-sm font-medium tracking-wide transition-colors duration-300 relative ${
                                    isActive
                                        ? "text-[#4A3728]"
                                        : "text-[#5C534D] hover:text-[#2C2724]"
                                } after:content-[''] after:absolute after:-bottom-1 after:left-0 after:h-px after:bg-[#C98A4B] after:transition-all after:duration-500 ${
                                    isActive
                                        ? "after:w-full"
                                        : "after:w-0 hover:after:w-full"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <Link
                    to="/ajanlatkeres"
                    data-testid="nav-cta-button"
                    className="hidden lg:inline-flex items-center px-5 py-2.5 bg-[#4A3728] text-[#F9F6F0] text-sm font-medium tracking-wide hover:bg-[#2C2724] transition-colors duration-500"
                >
                    Ajánlatkérés
                </Link>

                <button
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen(!open)}
                    aria-label="Menü"
                    className="lg:hidden p-2 text-[#2C2724]"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="lg:hidden bg-[#F9F6F0] border-t border-[#4A3728]/10 px-6 py-6 flex flex-col gap-4"
                >
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`mobile-nav-${l.label
                                .toLowerCase()
                                .replace(/\s/g, "-")}-link`}
                            className={({ isActive }) =>
                                `text-base font-medium py-2 ${
                                    isActive
                                        ? "text-[#4A3728]"
                                        : "text-[#5C534D]"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </div>
            )}
        </header>
    );
}
